var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcNo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 584,
    height: 584,
    viewBox: "0 0 584 584",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "114.1%",
    height: "114.1%",
    x: "-7.6%",
    y: "-6.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: "116.6%",
    height: "116.6%",
    x: "-8.9%",
    y: "-7.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 4.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0.811764706 0 0 0 0 0 0 0 0 0 0.294117647 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2",
    values: "0 0 0 0 0.811764706 0 0 0 0 0 0 0 0 0 0.294117647 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M256,0 C397.384896,0 512,114.615104 512,256 C512,397.384896 397.384896,512 256,512 C114.615104,512 0,397.384896 0,256 C0,114.615104 114.615104,0 256,0 Z M256,40 C136.706494,40 40,136.706494 40,256 C40,375.293506 136.706494,472 256,472 C375.293506,472 472,375.293506 472,256 C472,136.706494 375.293506,40 256,40 Z M152.623013,152.623013 C160.78703,144.458996 174.41277,144.458996 182.576787,152.623013 L255.292893,225.339119 L256,226.046226 L329.423213,152.623013 C337.58723,144.458996 351.21297,144.458996 359.376987,152.623013 C367.541004,160.78703 367.541004,174.41277 359.376987,182.576787 L286.660881,255.292893 L285.953774,256 L359.376987,329.423213 C367.541011,337.587237 367.541011,351.212007 359.376987,359.376987 C351.21297,367.541004 337.58723,367.541004 329.423213,359.376987 L256,285.953774 L255.292893,286.660881 L182.576787,359.376987 C174.41277,367.541004 160.78703,367.541004 152.623013,359.376987 C144.458996,351.21297 144.458996,337.58723 152.623013,329.423213 L226.046226,256 L225.339119,255.292893 L152.623013,182.576787 C144.458996,174.41277 144.458996,160.78703 152.623013,152.623013 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    transform: "translate(39 32)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "#000",
    filter: "url(#c)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "#CF004B"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#CF004B",
    d: "M256,0 C397.384896,0 512,114.615104 512,256 C512,397.384896 397.384896,512 256,512 C114.615104,512 0,397.384896 0,256 C0,114.615104 114.615104,0 256,0 Z M256,40 C136.706494,40 40,136.706494 40,256 C40,375.293506 136.706494,472 256,472 C375.293506,472 472,375.293506 472,256 C472,136.706494 375.293506,40 256,40 Z M152.623013,152.623013 C160.78703,144.458996 174.41277,144.458996 182.576787,152.623013 L255.292893,225.339119 L256,226.046226 L329.423213,152.623013 C337.58723,144.458996 351.21297,144.458996 359.376987,152.623013 C367.541004,160.78703 367.541004,174.41277 359.376987,182.576787 L286.660881,255.292893 L285.953774,256 L359.376987,329.423213 C367.541011,337.587237 367.541011,351.212007 359.376987,359.376987 C351.21297,367.541004 337.58723,367.541004 329.423213,359.376987 L256,285.953774 L255.292893,286.660881 L182.576787,359.376987 C174.41277,367.541004 160.78703,367.541004 152.623013,359.376987 C144.458996,351.21297 144.458996,337.58723 152.623013,329.423213 L226.046226,256 L225.339119,255.292893 L152.623013,182.576787 C144.458996,174.41277 144.458996,160.78703 152.623013,152.623013 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNo);
export default __webpack_public_path__ + "static/media/ic_no.c9b37d1543dd46f9f9061abee904f5f3.svg";
export { ForwardRef as ReactComponent };